export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10704.1eb2f3c0.jpg";